export default __webpack_public_path__ + "static/media/background.917c9a04.webp";